/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceConnectionStatusDto
 */
export interface DeviceConnectionStatusDto {
    /**
     *
     * @type {string}
     * @memberof DeviceConnectionStatusDto
     */
    deviceIdentity: string;
    /**
     *
     * @type {boolean}
     * @memberof DeviceConnectionStatusDto
     */
    pointedToIlluminate: boolean;
    /**
     *
     * @type {string}
     * @memberof DeviceConnectionStatusDto
     */
    status: DeviceConnectionStatusDtoStatusEnum;
}

/**
 * @export
 */
export const DeviceConnectionStatusDtoStatusEnum = {
    Unknown: "Unknown",
    Online: "Online",
    Offline: "Offline",
} as const;
export type DeviceConnectionStatusDtoStatusEnum =
    (typeof DeviceConnectionStatusDtoStatusEnum)[keyof typeof DeviceConnectionStatusDtoStatusEnum];

/**
 * Check if a given object implements the DeviceConnectionStatusDto interface.
 */
export function instanceOfDeviceConnectionStatusDto(
    value: object,
): value is DeviceConnectionStatusDto {
    if (!("deviceIdentity" in value) || value["deviceIdentity"] === undefined)
        return false;
    if (
        !("pointedToIlluminate" in value) ||
        value["pointedToIlluminate"] === undefined
    )
        return false;
    if (!("status" in value) || value["status"] === undefined) return false;
    return true;
}

export function DeviceConnectionStatusDtoFromJSON(
    json: any,
): DeviceConnectionStatusDto {
    return DeviceConnectionStatusDtoFromJSONTyped(json, false);
}

export function DeviceConnectionStatusDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConnectionStatusDto {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity: json["deviceIdentity"],
        pointedToIlluminate: json["pointedToIlluminate"],
        status: json["status"],
    };
}

export function DeviceConnectionStatusDtoToJSON(
    value?: DeviceConnectionStatusDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        pointedToIlluminate: value["pointedToIlluminate"],
        status: value["status"],
    };
}
